'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'radio-tuner';
var width = 512;
var height = 512;
var aliases = ["radio-alt"];
var unicode = 'f8d8';
var svgPathData = 'M515.8-4.4l-7.8-31-15.5 3.9-480 120-12.1 3 0 388.5 512 0 0-384-398 0 385.9-96.5 15.5-3.9zM32.4 128l448 0 0 64-448 0 0-64zm0 144l0-48 448 0 0 224-448 0 0-176zm304 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-280-16a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm72 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRadioTuner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;